<template>
  <div class="row px-4">
    <div class="row mx-2" v-if="ListUser.length > 1">
      <div class="col-4 text-center mt-4">
        تنظیم شرط عبور از <span class="text-warning">{{ Data.LevelName }}</span> فــــرم <span class="text-warning">{{ Data.FormAutomationName }}</span>
      </div>

      <div class="col-2">
        <small>انتخاب کاراکتر </small>
        <select class="form-control text-center Pointer" @change="ChangeChar($event)" v-model="Char">
          <option :value="-1">یک کارکتر انتخاب کنید</option>
          <option>(</option>
          <option>)</option>
        </select>
      </div>

      <div class="col-4">
        <small>انتخاب نقش</small>
        <select class="form-control text-center Pointer" @change="ChangeUser($event)" v-model="User">
          <option v-for="(user, keyUser) in ListUser" :key="keyUser" :value="user">{{ user.tblUserRoleName }}</option>
        </select>
      </div>

      <div class="col-2">
        <small>انتخاب عبارت منطقی</small>
        <select class="form-control text-center Pointer" @change="ChangeAndOr($event)" v-model="AndOr">
          <option :value="-1">یک عبارت منطقی انتخاب کنید</option>
          <option>و</option>
          <option>یا</option>
        </select>
      </div>

      <div class="col-12 mt-2">
        <textarea class="form-control" rows="5" v-model="PersianText" disabled></textarea>
      </div>
      <div class="col-12 mt-2">
        <button class="btn btn-success float-left" @click="SubmitCondition"><i class="fad fa-check-circle mx-2"></i> ثبت تنظیمات</button>
        <button class="btn btn-warning float-left mx-2" @click="ClearCondition"><i class="fad fa-trash mx-2"></i> خالی کردن تنظیمات</button>
      </div>
    </div>
    <div class="row mx-2 mt-3" Id="ConditionCount">
      <div class="col-md-4 col-12 mt-3">
        <div class="mr-4 mt-4">
          تنظیم شرط تعداد برای عبور از <span class="text-warning">{{ Data.LevelName }}</span
          ><small class="d-none"> ( به صورت پیشفرض هیچ شرط تعداد وجود ندارد ) </small>
        </div>
      </div>
      <div class="col-md-3 col-12 mt-3">
        <small>انتخاب علائم</small>
        <select class="form-control" v-model="Conditioncount">
          <option :value="0">یکی از علائم را انتخاب کنید</option>
          <option :value="1">بیشـــــتر</option>
          <option :value="-1">کمـــــــتر</option>
        </select>
      </div>
      <div class="col-md-2 col-12 mt-3">
        <small>تعداد</small>
        <input type="text" class="form-control text-center required" maxlength="2" @keypress="$ValidNumber($event, 2, false)" v-model="Count" />
      </div>
      <div class="col-12 mt-2">
        <div class="mx-3 alert alert-secondary text-center">
          <span>اگر تعداد درخواست های کارمندان در ماه جاری </span>
          <span class="text-warning font-weight-bold">{{ Conditioncount == 1 ? 'بیشــــــتر' : Conditioncount == -1 ? 'کمــــــــتر' : 'حالتی انتخاب نشده' }}</span>
          <span> از </span>
          <span class="text-warning font-weight-bold">{{ Count }}</span>
          <span> درخواست باشد مجوز عبور از این سطح را دارد</span>
        </div>
      </div>
      <div class="col-12 mt-1">
        <button class="btn btn-success float-left" @click="SaveConditioncount"><i class="fad fa-check-circle mx-2"></i> ثبت شرط تعداد</button>
        <button class="btn btn-warning float-left mx-2"><i class="fad fa-trash mx-2"></i> خالی کردن تنظیمات</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ListUser: [],
      Char: -1,
      AndOr: -1,
      User: {},
      PersianText: '',
      Text: [],
      Count: 0,
      Conditioncount: 0,
    }
  },
  props: ['Data', 'Department'],
  created() {
    this.ListUser = this.Data.tblUserRols
    this.GetCondition()
  },
  methods: {
    ChangeUser(e) {
      let findUser = false
      this.Text.forEach((el) => {
        if (el == this.User.tblUserRoleId) {
          findUser = true
        }
      })
      if (typeof this.Text[this.Text.length - 1] == 'number') {
        this.$toasted.error('امکان انتخاب دو نقش بلافاصله از هم وجود ندارد ، باید میان نقش ها از عبارات منطقی استفاده شود', { duration: 5000 })
      } else if (this.Text[this.Text.length - 1] === ')') {
        this.$toasted.error('امکان انتخاب نقش پس از علامت ) بسته وجود ندارد و باید قبل انتخاب نقش یک عبارت منطقی انتخاب کنید', { duration: 5000 })
      } else if (findUser) {
        this.$toasted.error('نقش وارد شده تکراری می باشد', { duration: 5000 })
      } else {
        this.PersianText = this.PersianText + ' ' + this.User.tblUserRoleName
        this.Text.push(this.User.tblUserRoleId)
      }
      this.User = {}
    },
    ChangeChar(e) {
      if (e.target.value != -1) {
        if (typeof this.Text[this.Text.length - 1] == 'number' && e.target.value === '(') {
          this.$toasted.error('امکان انتخاب کاراکتر ( بلافاصله پس از کاربر وجود ندارد', { duration: 5000 })
        }
        // else if(e.target.value===')'){
        //   this.$toasted.error('امکان انتخاب کاراکتر ) بلافاصله پس از دیگری امکان پذیر نمی باشد', { duration: 5000 })
        // }
        else {
          this.PersianText = this.PersianText + ' ' + e.target.value
          this.Text.push(e.target.value)
        }
        this.Char = -1
      }
    },
    ChangeAndOr(e) {
      if (e.target.value != -1) {
        if (this.Text[this.Text.length - 1] === 'و' || this.Text[this.Text.length - 1] === 'یا') {
          this.$toasted.error('امکان انتخاب دو عبارت منطقی بلافاصله از هم وجود ندارد و باید بعد از هرعبارت منطقی کاربر وارد شود', { duration: 5000 })
        } else {
          console.log(e.target.value)
          this.PersianText = this.PersianText + ' ' + e.target.value
          this.Text.push(e.target.value)
        }
        this.AndOr = -1
      }
    },
    ClearCondition() {
      this.Text = []
      this.PersianText = ''
      this.$toasted.success('مقادیر شرط ها  با موفقیت خالی شدن', { duration: 1000 })
    },
    SubmitCondition() {
      let Open = 0
      let Close = 0
      let User = 0
      let FullText = ''
      this.Text.forEach((el) => {
        if (el == ')') {
          Open++
          FullText = FullText + el
        }
        if (el == '(') {
          Close++
          FullText = FullText + el
        }
        if (typeof el == 'number') {
          User++
          FullText = FullText + el
        }
        if (el === 'و') {
          FullText = FullText + 'And'
        }
        if (el === 'یا') {
          FullText = FullText + 'Or'
        }
      })
      if (Open == Close) {
        let DataAxios = {
          tblWorkFlowId: this.Data.tblWorkFlowId,
          tartib: this.Data.tartib,
          Condition: FullText,
          PersianCondition: this.PersianText,
        }
        let DataAxios_SetData = {
          ArryfildValue: {},
          Method: 'post',
          Action: 'WorkflowCondition/SetCondaition',
          Token: this.$session.get('Token'),
        }
        DataAxios_SetData.ArryfildValue = DataAxios
        this.$PostData(DataAxios_SetData)
          .then((data) => {
            if (data.status == 'Ok') {
              this.$toasted.success(data.msg, { duration: 2000 })
            }
          })
          .finally(() => {
            this.$emit('Close', true)
          })
      } else {
        this.$toasted.error('خطای منطقی ، در شرط وارد شده تعداد پرانتز های باز و بسته برابر نیستند', { duration: 3000 })
      }
    },
    GetCondition() {
      let DataAxios = {
        tblWorkFlowId: this.Data.tblWorkFlowId,
        tartib: this.Data.tartib,
      }
      let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'WorkflowCondition/GetCondaition',
        Token: this.$session.get('Token'),
      }
      DataAxios_SetData.ArryfildValue = DataAxios
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.PersianText = data.data.persianCondition
            this.Text = data.data.condition.split(/[.\(AndOr)/_]/)
            this.Text = this.Text.filter((z) => z.trim() != '')
            if (data.data.conditionCount != null) {
              let text = data.data.conditionCount
              // جستجوی الگوی مقایسه
              let regex = /(<=?|>=?|===?|!==?)\s*(\d+)/g
              // مطابقت الگو با متن
              let match = regex.exec(text)
              // اگر مطابقت پیدا شد
              if (match) {
                // علامت مقایسه
                let operator = match[1]
                // مقدار مقایسه
                let value = parseInt(match[2])

                this.Count = value
                // انجام عمل مورد نظر بر اساس مقدار و علامت
                if (operator === '>') {
                  this.Conditioncount = 1
                } else if (operator === '<') {
                  this.Conditioncount = -1
                } else {
                  console.error('متن مطابق با شرط مورد نظر نیست.')
                }
              } else {
                console.error('الگوی مورد نظر در متن پیدا نشد.')
              }
            }
            else{
            this.$toasted.info('تنظیماتی از قبل صورت نگرفته ، تنظیمات خودرا وارد کنید',{duration:2000})
            }
          }
        })
        .finally(() => {})
    },
    SaveConditioncount() {
      if (!this.$ValidForm('ConditionCount')) {
        this.$toasted.error('فیلد مشخص شده الزامی می باشد', { duration: 2000 })
      } else if (this.Conditioncount == 0) {
        this.$toasted.error('تعداد باید بیشتر از صفر و یکی از علائم هم باید درحالت انتخاب باشد', { duration: 2000 })
      } else {
        
        let CCount = null;
        if (this.Count!="0" && this.Count!=0 && this.Count!='') {
          this.Conditioncount == 1 ? (CCount = 'ReqCount > ' + this.Count) : ''
          this.Conditioncount == -1 ? (CCount = 'ReqCount < ' + this.Count) : ''
        }
        else{
          CCount=null;  
        }
        let DataAxios = {
          tblWorkFlowId: this.Data.tblWorkFlowId,
          tartib: this.Data.tartib,
          conditionCount: CCount,
        }
        let DataAxios_SetData = {
          ArryfildValue: {},
          Method: 'post',
          Action: 'WorkflowCondition/SetCondaitionCount',
          Token: this.$session.get('Token'),
        }
        DataAxios_SetData.ArryfildValue = DataAxios
        this.$PostData(DataAxios_SetData)
          .then((data) => {
            if (data.status == 'Ok') {
              this.$toasted.success(data.msg, { duration: 2000 })
            }
          })
          .finally(() => {
            this.$emit('Close', true)
          })
      }
    },
  },
}
</script>
